<template>
  <div>
    <el-dialog title="设置" center :visible="true" :close-on-click-modal="false" :close-on-press-escape="false"
      :show-close="true" :before-close="onClose" width="501px">
      <el-form ref="form" :model="form" label-width="150px" size="mini" style="width: 450px">
        <el-form-item label="低于该版本需要强更: " prop="clientForceUpdateMinVersion">
          <el-input style="width: 100px" v-model="form.minVersion" clearable></el-input>
        </el-form-item>
        <el-form-item label="强更跳转链接: " prop="clientForceUpdateMinUrl">
          <el-input style="width: 300px" v-model="form.url" clearable></el-input>
        </el-form-item>
      </el-form>
      <p align="center" style="color: red;">*修改后可能会延迟2秒左右才会生效*</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose()">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
import util from "@/util";
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

// 本弹窗名称
const DialogName = "EditForceUpdateConfigDialog";

export default {
  data() {
    return {
      form: {
        minVersion: "",
        url: "",
      },
    };
  },
  components: {},

  created() {
    let externalData = dialogutil.getData(DialogName);

    this.form.minVersion = externalData.minVersion;
    this.form.url = externalData.url;
  },

  methods: {
    async submit() {
      try {
        // 弹确认框
        await this.$confirm(`确认修改？`);
        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/api/admin/v1/forceUpdate/updateForceUpdateConfig`,
            {
              minVersion: this.form.minVersion,
              url: this.form.url,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message({
            message: resData.message,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onClose(null);
      } catch (e) { }
    },

    onClose(done) {
      // 关闭当前对话框
      dialogutil.close(DialogName);
    },
  },
};
</script>